import React from 'react';

const PageNotFound = () => {
    return (
        <div>
            <h2 className='text-5xl' > 404 Page Not Found </h2>
        </div>
    );
};

export default PageNotFound;